module.exports = __webpack_public_path__ + "fonts/overvoice2.4792165.ttf";